//  仓位设置信息
<template>
  <div id="containt" class="detail-wrap">
    <el-form ref="editForm" :model="requestParam">
      <div class="d-header clearfix">
        <div class="fl">
          <i class="el-icon-info"/>
          仓位设置信息
        </div>
        <div class="fr">
<!--          <el-button icon="el-icon-brush" class="button-sty btn_color" @click="resetEvent">重置</el-button>-->
          <el-button type="warning" class="button-sty" icon="el-icon-search" @click="searchEvent">搜索</el-button>

        </div>
      </div>
      <div class="grid-height" style="display:flex;flex-direction: column;">
        <div>
          <div class="input_main">
            <div class="main">
              <el-form class="screen-box" title-width="92px" title-align="right" :data="formData"
              @submit="toFilterData" @keyup.enter.native="toFilterData" @reset="searchEvent">
                <div class="main_item">

                  <el-form-item>
                    <div class="item_items">
                      <span>仓库编码:</span>
                      <el-input v-model="searchWarehouseCode" placeholder="请输入仓库编码"></el-input>
                    </div>
                  </el-form-item>
                  <el-form-item>
                    <div class="item_items">
                      <span>仓库名称:</span>
                      <el-input v-model="searchWarehouseName" placeholder="请输入仓库名称"></el-input>
                    </div>
                  </el-form-item>
<!--                  <el-form-item>-->
<!--                    <div class="item_items">-->
<!--                      <span>库位编码:</span>-->
<!--                      <el-input v-model="formData.num3" placeholder="请输入库位编码"></el-input>-->
<!--                    </div>-->
<!--                  </el-form-item>-->
<!--                  <el-form-item>-->
<!--                    <div class="item_items">-->
<!--                      <span>库位名称:</span>-->
<!--                      <el-input v-model="formData.tableDataName2" placeholder="请输入库位名称"></el-input>-->
<!--                    </div>-->
<!--                  </el-form-item>-->
                </div>
              </el-form>
            </div>
            <!-- <el-button type="primary" @click="doFilter">搜索</el-button> -->

          </div>
        </div>
        <!-- 左边------- 树型结构 -->
        <div style="display:flex;    margin-left: 10px;">
          <div class="left_tree">
            <div class="title1" style=" display: none;border-top: 1px solid #ededed;"></div>
            <div style="height: 100vh;">
              <!-- <div class="title"> <svg t="1676961094129" class="icon tree_icon" viewBox="0 0 1024 1024"
                  version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2887" width="20" height="20">
                  <path
                    d="M384 725.333333c0 21.333333 17.066667 38.4 38.4 42.666667H640v-42.666667c0-21.333333 17.066667-38.4 38.4-42.666666H853.333333c25.6 0 42.666667 17.066667 42.666667 42.666666v170.666667c0 25.6-17.066667 42.666667-42.666667 42.666667h-170.666666c-25.6 0-42.666667-17.066667-42.666667-42.666667v-42.666667h-213.333333c-68.266667 0-123.733333-51.2-128-119.466666V341.333333H170.666667c-21.333333 0-38.4-17.066667-42.666667-38.4V128c0-25.6 17.066667-42.666667 42.666667-42.666667h341.333333c25.6 0 42.666667 17.066667 42.666667 42.666667v170.666667c0 25.6-17.066667 42.666667-42.666667 42.666666H384v128h256v-42.666666c0-21.333333 17.066667-38.4 38.4-42.666667H853.333333c25.6 0 42.666667 17.066667 42.666667 42.666667v170.666666c0 25.6-17.066667 42.666667-42.666667 42.666667h-170.666666c-25.6 0-42.666667-17.066667-42.666667-42.666667v-42.666666H384v170.666666z m426.666667 42.666667h-85.333334v85.333333h85.333334v-85.333333z m0-298.666667h-85.333334v85.333334h85.333334v-85.333334z m-341.333334-298.666666H213.333333v85.333333h256V170.666667z"
                    fill="#1296db" p-id="2888"></path>
                </svg>

                <span>商品分类</span>
              </div> -->
              <!-- <el-input placeholder="关键字过滤" v-model="filterText">
              </el-input> -->

              <!-- <el-tree class="tree-line" :data="data" :props="defaultProps" @node-click="handleNodeClick"
                :filter-node-method="filterNode" ref="tree">
              </el-tree> -->
            </div>
          </div>
          <!-- 中间边表结构 -->
          <div class="table_main" style="height: calc(100vh - 125px);">
            <div class="title1">仓库表</div>
            <vxe-grid  :stripe="true" border="default"  show-overflow height="100%" ref="table-m1"
                      v-bind="vxeOption" @resizable-change="$vxeTableUtil.onColumnWitchChange"
                      @custom="$vxeTableUtil.customHandle" @current-change="currentHandler">
              <template #form>
              </template>
              <!-- 分页器 -->
              <template #pager>
                <pager ref="pager" :page-sizes="pageSizes" @changeTablePage="changeTablePage"></pager>
              </template>
            </vxe-grid>
          </div>
          <!-- 右边表结构 -->
          <div class="table_main" style="height: calc(100vh - 129px);">
            <div class="title1">仓库库位表</div>
            <vxe-grid style="margin-left: 5px;" :stripe="true"  border="default" :row-config="{ isHover: true }" show-overflow height="100%" ref="table-m2"
                      v-bind="vxeOption1" @resizable-change="$vxeTableUtil.onColumnWitchChange"
                      @custom="$vxeTableUtil.customHandle">
              <template #form>
              </template>
              <!-- 分页器 -->
              <template #pager>

                <el-button type="primary" :disabled="!warehouse_location_add" class="button-sty btn_zdy2" @click="openAddWind">
                  <i class="el-icon-plus"></i>
                  添加库位
                </el-button>


              </template>
            </vxe-grid>
          </div>
        </div>
      </div>

    </el-form>
    <el-dialog style="padding: 40px 20px " :close-on-click-modal="false" :visible.sync="addDialogVisible"
               width="30%" top="5vh" :show-close="true" :before-close="addHandleClose"
               :title="addDialogTitle == 'edit' ? '编辑名称' : '新增分类'">
      <el-form :model="addForm" :rules="addRules" label-width="100px" ref="addRef">
        <el-form-item label="仓库名称" prop="name">
<!--          <el-input size="medium" :maxlength="50" v-model="formData.warehouseName" placeholder="请选择仓库名称"-->
<!--                    readonly="true">-->
<!--            <i slot="suffix" class="el-input__icon el-icon-search" @click="showPreconditionDialog=true"></i>-->
<!--          </el-input>-->
          <el-input size="medium" :maxlength="10" v-model="formData.warehouseName" :disabled="true" placeholder="请输入库位编码"/>
        </el-form-item>
        <el-form-item label="库位编码" prop="code">
          <el-input size="medium" :maxlength="10" v-model="formData.locationCode" placeholder="请输入库位编码"/>
        </el-form-item>
        <el-form-item label="库位名称" prop="code">
          <el-input size="medium" v-model="formData.locationName" placeholder="请输入库位名称"/>
        </el-form-item>
        <el-form-item label="仓管员">
          <el-input size="medium" v-model="formData.warehouseMan" placeholder="请输入仓管员"/>
        </el-form-item>
        <el-form-item label="启用" prop="usable">
          <el-select v-model="formData.usable">
            <el-option label="禁用" :value="0"/>
            <el-option label="启用" :value="1"/>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAddDialog">取 消</el-button>
        <el-button size="small" type="primary" @click="addData"
                   v-if="(warehouse_location_edit && formData.id != null)
                   || (warehouse_location_add && formData.id == null)"
        >确 定</el-button>
      </span>
    </el-dialog>
<!--    <preconditionDialog v-if="showPreconditionDialog" @commitSelectedRow="commitSelectedRow"-->
<!--                        :visiable.sync="showPreconditionDialog" multi="true"-->
<!--    />-->
  </div>
</template>

<script>
import {initVxeTable} from '@/const/crud/admin/table';
import pager from '@/components/pager/index.vue';
import preconditionDialog from './dialog';
import {initVxeTableNoTotal} from "@/const/crud/admin/tableNoTotal";
import {mapGetters} from "vuex";

export default {
  name: 'storage',

  components: {pager, preconditionDialog,},
  data() {
    return {
      warehouse_location_edit: false,
      warehouse_location_add: false,
      total: 0,
      getDataUrl: '/basic/basWarehouseLocation/getById',
      getPageDataUrl: '/basic/basWarehouse/getListPage',
      getWarehouseLocationListPageUrl: '/basic/basWarehouseLocation/getList',
      addDataUrl: '/basic/basWarehouseLocation/add',
      updateDataUrl: '/basic/basWarehouseLocation/update',
      showPreconditionDialog: false,
      addRules: {
        name: [{
          required: true,
          message: "请输入名称",
          trigger: "blur"
        }],
        code: [{
          required: true,
          message: "请输入编码",
          trigger: "blur"
        }],
        usable: [{required: true}]
      },
      addDialogTitle: "new",
      addForm: {
        name: "",
        code: ""
      },
      requestParam: {
        size: 0,
        current: 1,
        searchCount: false,
        warehouseName: '',
        warehouseCode: '',
        excludeWarehouseType: [3]
      },
      addDialogVisible: false,

      formData: {
        id: null,  // 主键id,自动新增
        warehouseId: '',  // 仓库ID,关联bas_warehouse.id
        locationCode: '',  // 库位编码,同一个仓库ID下不能重复
        locationName: '',  // 库位名称
        warehouseMan: '',  // 仓管员
        usable: 1,  // 启用:0禁用；1启用
        warehouseName: ''  // 显示用
      },
      searchWarehouseName: '',
      searchWarehouseCode: '',
      pageSizes: [10, 20, 100],
      activeName: 'second',
      dataId: 0,
      showEdit: false,
      vxeOption: {},
      vxeOption1: {},
      columns: [
        {type: 'seq', width: 60, title: '序号', resizable: false, fixed: 'left'},
        { title: '仓库编码', field: 'warehouseCode', width: 100, },
        { title: '仓库名称', field: 'warehouseName', width: 100, },
        { title: '仓库类型', field: 'warehouseType', width: 100, slots: {
            default: ({row}) => {
              if (row.warehouseType == 0) {
                return [
                  <div>
                    <span>总部仓</span>
                  </div>
                ];
              } else if (row.warehouseType == 1) {
                return [
                  <div>
                    <span>机构仓</span>
                  </div>
                ];
              } else if (row.warehouseType == 2) {
                return [
                  <div>
                    <span>代理仓</span>
                  </div>
                ];
              } else if (row.warehouseType == 3) {
                return [
                  <div>
                    <span>网点仓</span>
                  </div>
                ];
              }
            }
          }},
        { title: '关联网点名称', field: 'siteName', width: 100, },
        { title: '是否配件仓态', field: 'isPartsWare', width: 100, slots: {
            default: ({row}) => {
              if (row.isPartsWare == 0) {
                return [
                  <div class="txt-status disable">
                    <span>否</span>
                  </div>
                ];
              } else if (row.isPartsWare == 1) {
                return [
                  <div class="txt-status">
                    <span>是</span>
                  </div>
                ];
              }
            }
          }
        },
        { title: '是否产品仓', field: 'isItemWare', width: 100, slots: {
            default: ({row}) => {
              if (row.isItemWare == 0) {
                return [
                  <div class="txt-status disable">
                    <span>否</span>
                  </div>
                ];
              } else if (row.isItemWare == 1) {
                return [
                  <div class="txt-status">
                    <span>是</span>
                  </div>
                ];
              }
            }
          }
        },
        { title: '启用', field: 'usable', width: 100, slots: {
            default: ({row}) => {
              if (row.usable == 0) {
                return [
                  <div class="txt-status disable">
                    <span>禁用</span>
                  </div>
                ];
              } else if (row.usable == 1) {
                return [
                  <div class="txt-status">
                    <span>启用</span>
                  </div>
                ];
              }
            }
          }
        },
      ],
      columns1: [
        {type: 'seq', width: 60, title: '序号', resizable: false, fixed: 'left'},
        { title: '仓库名称', field: 'warehouseName', width: 100, },
        { title: '库位编码', field: 'locationCode', width: 100, },
        { title: '库位名称', field: 'locationName', width: 100, },
        { title: '仓管员', field: 'warehouseMan', width: 90, },
        { title: '启用', field: 'usable', width: 90, slots: {
            default: ({row}) => {
              if (row.usable == 1) {
                return [
                  <div class="txt-status">
                    <span>启用</span>
                  </div>
                ];
              } else if (row.usable == 0) {
                return [
                  <div class="txt-status disable">
                    <span>禁用</span>
                  </div>
                ];
              }
            }
          }
        },
        { width: 60, title: '操作', sortable: false, fixed: 'right', slots: {
            default: ({row}) => {
              return [
                <div>
                  <a href="javascript:void(0);"
                    class="a-link"
                    onclick={ () => {
                      this.openEditDialog(row.id);
                    }}
                  >
                    <el-tooltip enterable={false} effect="dark" content="查看" placement="top"
                                popper-class="tooltip-skin">
                      <i class="el-icon-edit"/>
                    </el-tooltip>
                  </a>
                </div>
              ];
            }
          }
        }
      ]
    }
  },
  computed: {
    getDataParams() {
      return {warehouseId: this.formData.warehouseId}
    },

    ...mapGetters(["permissions"])
  },
  created() {
    this.warehouse_location_edit = this.permissions['warehouse_location_edit']
    this.warehouse_location_add = this.permissions['warehouse_location_add']
  },
    watch: {
    total(newVal) {
      this.$refs.pager.tableDataTotal = newVal
    },
  },
  methods: {
    toFilterData() {
          // console.log(55,"触发了搜索");
    // 当用户没有输入内容就按enter键时，就return，不做任何操作，不去搜索
        if(this.formData === '') {
             return
        } else {
        // 请求查询接口，将列表展现出来
            this.searchEvent();
         }
     },
    // 刷新
    flushed() {
      this.$refs['table-m1'].commitProxy('reload');
    },
    flushed2() {
      this.$refs['table-m2'].commitProxy('reload');
    },

    // 加载仓库table数据
    getTableData() {
      let tableOption = {
        vue: this,
        tableRef: 'table-m1',
        path: this.getPageDataUrl,
        param: this.requestParam,
        method: 'post',
        columns: this.columns
      }
      let initVxeTable1 = initVxeTable(tableOption);
      initVxeTable1.rowConfig = {isCurrent: true}
      this.vxeOption = initVxeTable1;
      this.editViewDataUpdateFlag = false;
      this.flushed()
    },

    // 分页功能
    changeTablePage(page, flag) {
      this.requestParam.size = page.pageSize
      this.requestParam.current = page.currentPage
      this.requestParam.searchCount = flag
      this.formData.warehouseId = ''
      this.formData.warehouseName = ''
      this.flushed2()
      this.getTableData()
    },

    currentHandler({row}) {
      console.log(row.id)
      this.formData.warehouseId = row.id
      this.formData.warehouseName = row.warehouseName
      this.getTableData1()
    },

    // 加载库位table数据
    getTableData1() {
      let tableOption = {
        vue: this,
        tableRef: 'table-m2',
        path: this.getWarehouseLocationListPageUrl,
        method: 'post',
        columns: this.columns1
      }
      this.vxeOption1 = initVxeTableNoTotal(tableOption);
      this.flushed2()
    },

    commitSelectedRow(data) {
      this.formData.warehouseName = data.warehouseName
      this.formData.warehouseId = data.id
    },

    // 添加数据
    addData() {
      this.$http({
        url: this.addDialogTitle === 'new' ? this.addDataUrl : this.updateDataUrl,
        method: 'post',
        data: this.formData
      }).then(res => {
        this.$message.success('保存成功')
        this.addDialogVisible = false

        this.formData.id = null  // 主键id,自动新增
        this.formData.locationCode = ''  // 库位编码,同一个仓库ID下不能重复
        this.formData.locationName = ''  // 库位名称
        this.formData.warehouseMan = ''  // 仓管员
        this.formData.usable = 0  // 启用:0禁用；1启用

        // this.flushed()
        this.flushed2()
      })
    },






    closeAddDialog() {
      this.addDialogVisible = false
      this.formData.id = null
      this.formData.locationCode = ''
      this.formData.locationName =  ''
      this.formData.warehouseMan = ''
      this.formData.usable = 0
      this.requestParam.usable = 1
    },
    addHandleClose() {
      this.addDialogVisible = false;
      this.$refs.addRef.resetFields();
    },

    openAddWind() {
      if (this.formData.warehouseId === '') {
        this.$message.warning('请先选中仓库！')
      } else {
        this.addDialogVisible = true;
        this.addDialogTitle = "new";
      }
    },
    // 以上弹框事件


    searchEvent() {
      this.requestParam.warehouseName = this.searchWarehouseName
      this.requestParam.warehouseCode = this.searchWarehouseCode
      this.$refs.pager.clearStoreTableDataTotal()
      this.requestParam.current = 1
      this.requestParam.searchCount = false
      this.$refs.pager.reset()  // 重置分页器
      this.formData.warehouseId = ''
      this.formData.warehouseName = ''
      this.flushed()
      this.flushed2()
    },

    // 重置
    resetEvent() {
      this.searchWarehouseName = ''
      this.searchWarehouseCode =  ''
      this.formData = {
        id: '',  // 主键id,自动新增
        warehouseId: '',  // 仓库ID,关联bas_warehouse.id
        locationCode: '',  // 库位编码,同一个仓库ID下不能重复
        locationName: '',  // 库位名称
        warehouseMan: '',  // 仓管员
        usable: 0,  // 启用:0禁用；1启用
        warehouseName: ''  // 显示用
      }
      this.requestParam.warehouseCode = ''
      this.requestParam.warehouseName = ''
      this.requestParam.current = 1
      this.requestParam.searchCount = false
      this.$refs.pager.reset()  // 重置分页器
      this.flushed()
      this.flushed2()
    },

    // 新增
    openEditDialog(id) {
      this.addDialogTitle = "edit";
      this.dataId = !id || typeof id == 'object' ? 0 : id;
      this.activeName = 'first';
      this.$http({
        url: this.getDataUrl,
        method: 'post',
        data: {id: id}
      }).then(res => {
        this.formData = res.data.data
        this.addDialogVisible = true;
      })
    },

  }
};
</script>
<style lang="scss" scoped>
#containt {
  overflow-y: hidden;
}

::v-deep .grid-height {
  height: calc(100vh - 47px) !important;
}


.table_main {
  // padding-top: 5px;
  // padding-left: 5px;
  // border: 1px solid #ededed;
  width: 50%;
  border-bottom: none;

  .el-pagination {

    padding: 2px;

  }
}

.title1 {
  text-align: center;
  background-color: #F6FAFF;;
  // margin-bottom: 10px;
  padding: 5px;
  font-weight: 600;
  color: #666;

}

.left_tree {
  // width: 205px;

  .title {
    text-align: left;
    width: 182px;
    padding: 7px 0 5px !important;
    font-size: 13px;
    color: rgba(58, 39, 39, 0.96);

    > span {
      position: relative;
      left: 4px;
      top: -3px;

    }
  }

  ::v-deep.el-tree-node__label {
    width: calc(100% - 32px);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 12px;
    color: rgba(86, 86, 86, 0.96);
  }
}

.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}

.tree_icon {
  background: #f0f3ff;
}

// 重新修改tree组件样式 记得在树里加class="tree-line"
::v-deep.tree-line {
  .el-tree-node {
    position: relative;
    padding-left: 0px;
  }

  .el-tree-node__content {
    margin-top: 0px;
  }

  .el-tree-node__children {
    padding-left: 16px;
  }

  .el-tree-node::before {
    content: '';
    height: 100%;
    width: 1px;
    position: absolute;
    left: -3px;
    top: -26px;
    border-width: 1px;
    border-left: 1px dashed #d9d9d9;
  }

  .el-tree-node:last-child::before {
    height: 38px;
  }

  .el-tree-node::after {
    content: '';
    width: 24px;
    height: 1px;
    position: absolute;
    left: -3px;
    top: 12px;
    border-width: 1px;
    border-top: 1px dashed #d9d9d9;
  }

  & > .el-tree-node::after {
    border-top: none;
  }

  & > .el-tree-node::before {
    border-left: none;
  }

  .el-tree-node__expand-icon {
    font-size: 17px;

    // color: #000;
    &.is-leaf {
      color: transparent;
      // display: none;
    }
  }


}


.detail-wrap .d-header {
  height: 34px;
  line-height: 34px;
  margin: 7px 0px 0px 0px;
  padding: 0px 0px 0 14px;
  font-size: 13px;
  overflow: hidden;
  background-color: #FFF;

  .btn_color {
    color: #00c4b3;
    border: solid 1px rgba(42, 100, 148, 0.4);

  }

  .btn_color:hover {
    color: #357fbc;
    border-color: #357fbc;
    background-color: #ffffff;
  }
}

.detail-wrap .d-header .fl > i {
  color: #00c4b3;
  display: inline-block;
  vertical-align: middle;
  margin-right: 6px;
  margin-bottom: 1px;
  font-size: 14px;
  font-size: 14px;
}

.input_main {
  margin-left: 10px;

  .main {
    display: flex;
    flex-direction: column;
    background-color: #fff;

    .main_item {

      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      background-color: #F4F6FA;
      padding-top: 8px;
      margin: 0px 0px 5px 0px;
      border-top: solid 1px #E9E9E9;
      border-bottom: solid 1px #E9E9E9;

      .item_items {
        display: flex;
        margin-bottom: 8px;

        span {
          width: 112px;
          font-weight: 400;
          text-align: right;
          line-height: 28px;
          font-size: 12px;
          position: relative;
          padding: 0 10px 0 4px;
          color: rgba(86, 86, 86, 0.96);
        }

        .el-input {
          width: 60%
        }
      }
    }
  }

}

// .btn_dialog{
//     height: 48px;
//     margin-top: 8px;
//     margin-left: 10px;
// }
.btn_zdy2 {
  // 选取文件合同按钮
  margin-left: 10px;
  margin-bottom: 5px;
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}

.btn_zdy2:hover {
  color: #00c4b3 !important;
  border: 1px solid #00c4b3 !important;
}
</style>
